import { GeoJsonLayer } from "@deck.gl/layers";
import apiData from "lib/stores/apiData";
import mapData from "lib/stores/mapData";
import context from "lib/stores/context";
import setActiveCountry from "lib/helpers/setActiveCountry";
import getPolyFillColor from "lib/map/functions/getPolyFillColor";
import geojson from "lib/data/.geo.json";
import { easeOutBack } from "lib/helpers/math";

// Filter out features with no geometry
geojson.features = geojson.features.filter((d) => d.geometry);

// Define memoized functions to avoid recreating them on every layer update
const getLineColor = ({ properties }) => {
  const { activeCountry } = context;
  if (!activeCountry) return [25, 25, 25];
  if (properties.ISO_A3 === activeCountry) {
    switch (mapData.activeCategory) {
      case "prevalence":
        return [126, 178, 226];
      case "vulnerability":
        return [102, 171, 171];
      case "gov-response":
        return [255, 133, 115];
      default:
        return [255, 204, 43];
    }
  }
  return [25, 25, 25];
};

const getLineWidth = ({ properties }) => {
  const { activeCountry } = context;
  if (!activeCountry) return 0;
  if (properties.ISO_A3 === activeCountry) {
    return 4;
  }
  return 0;
};

const setCountryMapLayer = (
  activeCategory,
  hoveredPolygonIndex,
  activeCountry,
  activeView,
  year,
) => {
  const { productsCountry, showProducts, showProductsMobile } = mapData;
  const { countries } = apiData;

  // Get memoized function to avoid recreating it on every layer update
  const getFillColor = getPolyFillColor();

  return new GeoJsonLayer({
    id: "country-map",
    data: geojson,
    filled: true,
    lineWidthMinPixels: 0.5,
    lineWidthMaxPixels: 4,
    stroked: true,
    getLineColor,
    getLineWidth,
    opacity: 1,
    lineWidthUnits: "pixels",
    parameters: {
      depthTest: true,
    },
    getFillColor,
    getPolygon: (d) => d.polygon,
    updateTriggers: {
      getFillColor: [activeCategory, activeCountry, activeView, year],
      getElevation: [activeCountry],
      getLineWidth: [activeCountry],
      getLineColor: [activeCountry, mapData.activeCategory],
    },
    extruded: false,
    getElevation: (
      { properties },
    ) => (properties.ISO_A3 === context.activeCountry ? 1 : 0),
    pickable: true,
    onClick: ({ object }) => {
      try {
        const { ISO_A3 } = object.properties;
        if (!Object.keys(countries).includes(ISO_A3)) return;
        setActiveCountry(ISO_A3);
        if (countries[ISO_A3].g20) {
          mapData.productsCountry = ISO_A3;
          mapData.selectedProduct = "";
          mapData.showProducts = true;
          mapData.showProductsMobile = true;
        } else {
          mapData.productsCountry = "";
          mapData.showProducts = false;
          mapData.showProductsMobile = false;
          mapData.selectedProduct = "";
        }
      } catch (error) {}
    },
    onHover: ({ index }) => {
      try {
        mapData.hoveredPolygonIndex = index;
      } catch (error) {}
    },
    transitions: {
      getFillColor: {
        duration: 300,
        easing: easeOutBack,
      },
      getLineWidth: {
        duration: 1000,
        easing: easeOutBack,
      },
      getLineColor: {
        duration: 1000,
        easing: easeOutBack,
      },
    },
  });
};

export { setCountryMapLayer };
